<template>
  <div v-if="edit">
    <el-main>
    <div class="area" v-if="btnPermissionsStr.includes('view:bi:list')">
      <div class="p_btn" style="margin-bottom: 24px;">
        <div>
          <div class="mainTitle">背调列表</div>
        </div>
        <div data-permissions="func:bi:adddata" v-has>
          <button class="btn subbtn" @click="add">添加背调人</button>
        </div>
      </div>
      <div class="filterdiv">
        <div class="formslot">
          <el-form ref="form" label-position="right" :inline="true">
             <el-row>
               <el-col :span="6">
            <el-form-item label="姓名" width="auto" >
              <el-input
                ref="input"
                style="font-size: 12px"
                placeholder="请输入姓名"
                v-model="form.name"></el-input>
            </el-form-item> 
               </el-col>
               <el-col :span="6">
            <el-form-item label="手机号" width="auto">
              <el-input
                ref="input"
                style="font-size: 12px"
                placeholder="请输入手机号"
                v-model="form.mobile"
                type="number"></el-input>
            </el-form-item>
               </el-col>
               <el-col :span="6">
            <el-form-item label="项目类型">
              <el-select
                v-model="form.projectType"
                placeholder="请选择"
                class="common_query_choice">
                <el-option label="全部" value="0"></el-option>
                <el-option label="RPO" value="1"></el-option>
                <el-option label="嗖嗖管" value="2"></el-option>
              </el-select>
            </el-form-item>
               </el-col>
               <el-col :span="6">
            <el-form-item label="项目名称" width="auto">
              <el-input
                ref="input"
                style="font-size: 12px"
                placeholder="请输入项目名称"
                v-model="form.projectName"></el-input>
            </el-form-item>
               </el-col>
               <el-col :span="6">
            <el-form-item label="状态">
              <el-select
                v-model="form.type"
                placeholder="请选择"
                class="common_query_choice">
                <el-option label="全部" value="0"></el-option>
                <el-option label="待用户授权" value="1"></el-option>
                <el-option label="已完成" value="2"></el-option>
              </el-select>
            </el-form-item>
               </el-col>
               <el-col :span="6">
            <el-form-item label="信用评级">
              <el-select
                v-model="form.rating"
                placeholder="请选择"
                class="common_query_choice">
                <el-option label="全部" value="0"></el-option>
                <el-option label="安全" value="2"></el-option>
                <el-option label="存在风险" value="3"></el-option>
              </el-select>
            </el-form-item>
               </el-col>
               <el-col :span="6">
              <el-form-item label="添加时间">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="——"
                  start-placeholder="起始日期"
                  end-placeholder="截止日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels>
                </el-date-picker>
              </el-form-item>
               </el-col>
               <el-col :span="6">
              <el-form-item style="margin-left:20px">
                <button type="button" class="btn" @click="onreset" >
                  重置
                </button>
                <button type="button" class="subbtn btn" @click="onsubmit" style="margin-left:16px">
                  搜索
                </button>
              </el-form-item>
               </el-col>
             </el-row>
          </el-form>
        </div>
      </div>
      <div class="pagebtn" >
        <page
          v-show="list.length > 0"
          :pagesize.sync="form.pageSize"
          :page="form.pageNum"
          :total="total"
          @enter="cur"
        style="margin-left:-12px"

          ref="page"></page>
        <div v-if="list.length == 0"></div>
        <div class="btns">
          <div data-permissions="func:bi:exportresult" v-has> 
            <el-button
              size="medium"
              class="btn subbtn"
              @click="downLoad">导出背调结果</el-button>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table :data="list"  :row-style="{height:'40px'}" :cell-style="{padding: '0'}">
         <el-table-column label="编号" prop="id" min-width="10" align="left" >
            
          </el-table-column>
          <el-table-column label="姓名" prop="name" min-width="10" align="left" >
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="手机号" prop="mobile" min-width="10" align="left">
          </el-table-column>
          <el-table-column
            label="项目类型"
            prop="email"
            :show-overflow-tooltip="true"
            min-width="10" align="left">
           <template slot-scope="scope">
              <span v-if="scope.row.projectType == 1">RPO</span>
              <span v-if="scope.row.projectType == 2">嗖嗖管</span>
            </template>
          </el-table-column>
          <el-table-column
            label="项目名称"
            :show-overflow-tooltip="true"
            prop="projectName"
            min-width="10" align="left">
          </el-table-column>
          <el-table-column label="状态" prop="type" min-width="10" align="left">
            <template slot-scope="scope">
              <p v-if="scope.row.type == 1" class="lableP yellow">
                待用户授权
              </p>
              <p v-if="scope.row.type == 2" class="lableP green">
                已完成
              </p>
            </template>
          </el-table-column>
          <el-table-column label="信用评级" prop="rating" min-width="6" align="left">
             <template slot-scope="scope">
              <p v-if="scope.row.rating == 2" class="safe">安全</p>
              <p v-if="scope.row.rating == 3" class="unsafe">存在风险</p>
              <p v-if="scope.row.rating !== 2 && scope.row.rating !== 3">-</p> 
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="createUserName"  min-width="10" align="left">
          </el-table-column>
           <el-table-column label="添加时间"  :show-overflow-tooltip="true" prop="createTime"  min-width="10" align="left">
          </el-table-column>
          <el-table-column label="操作"   min-width="5" align="center">
            <template slot-scope="scope">
              <!-- <div>
                <el-dropdown v-if="scope.row.admin_type !== 0" placement="bottom" size="small">
                  <span class="el-dropdown-link menu">
                    <span></span>
                    <i>操作</i>
                  </span>
                  <el-dropdown-menu> -->
                    <div style="cursor:pointer;color:#6669e3" v-if="scope.row.type !== 2" data-permissions="func:bi:againsendmsg" v-has>
                      <span @click="onmodify(scope.row.biId,scope.row.sendCount)">重发短信</span>
                    </div>
                    <div style="cursor:pointer;color:#6669e3" v-if="scope.row.type == 2" data-permissions="func:bi:seeresult" v-has>
                      <span @click="onAuthority(scope.row.biId)">查看结果</span>
                    </div>
                  <!-- </el-dropdown-menu>
                </el-dropdown> -->
                <!-- <div class="menu" @mouseover="hqid(scope.row.id)" @mouseout="lkid">
                  <span></span>
                  <i>操作</i>
                  <div class="card" v-if="scope.row.id == checkid">
                    <p @click="seal(scope.row.id)">公司印章</p>
                    <p @click="update(scope.row)">编辑</p>
                    <p @click="deleteContractCompany(scope.row.id)">删除</p>
                  </div>
                </div> -->
              <!-- </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page 
        v-show="list.length > 0" 
        :pagesize.sync="form.pageSize" 
        :page="form.pageNum" 
        :total="total" 
        @enter="cur" 
        style="margin-left:-12px"

        ref="page"></page>
    </div>
    <div class="authority" v-else>
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    </el-main>
  </div>
</template>

<script>
export default {
  created() {
    //初始化数据
    this.load();
    // this.loadData();
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  },
  data() {
    return {
      edit: false,
      btnPermissionsStr: {},
      status: false,
      form: {
        name: "",
        mobile: "",
        projectType:'0',
        projectName:'',
        type:'0',
        rating:'0',
        startTime:'',
        endTime:'',
        pageNum: 1,
        pageSize: 10,
      },
      date:[],
      list: [],
      checkid: "",
      checkval: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      maskshow: false,
      masktype: "",
      id: "",
      mas:''
    };
  },
    watch: {
    pageNum: function (val, oldVal) {
      this.$refs.page.page = val;
    },
  },
  methods: {
    load() {
      let codes = "";
      this.$employAxios.get("/permission/getCodes").then((res) => {
        for (var i = 0; i < res.data.data.length; i++) {
          codes += res.data.data[i] + ",";
          var str = codes.substring(0, codes.length - 1);
        }
        codes = str;
        sessionStorage.clear();
        sessionStorage.setItem("btnPermissions", codes);
        this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
        if (this.btnPermissionsStr.includes("view:bi:list")) {
          this.loadData();
        }
        this.edit = true;
      });
    },
    	downLoad() {
				this.$confirm('下载到本地, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					// type: 'warning'
					iconClass: "el-icon-caveat",
				}).then(() => {
          const params = "name=" + this.form.name +
            "&mobile=" + this.form.mobile +
            "&projectType=" + this.form.projectType +
            "&projectName=" + this.form.projectName +
            "&type=" + this.form.type +
            "&rating=" + this.form.rating +
            "&startTime=" + this.form.startTime +
            "&endTime=" + this.form.endTime +
            "&pageNum=" + this.form.pageNum +
            "&pageSize=" + this.form.pageSize;
					this.$axios.post("bi/exportResult", params, {
						responseType: 'blob'
					  }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}} ).then(res => {
             
              let blob = res.data
              let a = document.createElement('a')
              let headers = res.headers;
              let fileName = headers['content-disposition'];
              a.download = decodeURI(fileName).replace("attachment;filename=", '');
              a.href = URL.createObjectURL(blob)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
            })
				}).catch(err => {
					console.log(err);
				})
			},

    back() {
      this.$router.push({ path: "/main" });
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      
      if (keyCode == 13) {
        this.onsubmit();
      }
    },

    //搜索
    onsubmit() {
      if (this.date[0]) {
        this.form.startTime = this.date[0]
      } else {
        this.form.startTime = ''
      }

      if (this.date[1]) {
        this.form.endTime = this.date[1]
      } else {
        this.form.endTime = ''
      }
      this.form.pageNum = 1
      this.loadData();
    },
    onreset() {
      // this.form = {}
      this.form.name = ""
      this.form.mobile=  ""
      this.form.projectType ='0'
      this.form.projectName=''
      this.form.type='0'
      this.form.rating='0'
      this.form.startTime=''
      this.form.endTime=''
      this.date = [];
      this.form.pageNum= 1,
      this.form.pageSize= 10,
      this.loadData();
    },
    // 加载列表
    loadData() {
       const params = this.form;
      return this.$axios.get("bi/queryBiData", {
          params,
        })
        .then((res) => {
          if (res.data.status == 2) {
            this.status = true;
          } else {
            this.list = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    add() {
      this.$router.push({
        path: "ssgBacktone/addBackMan",
      });
    },

    update(id) {
      this.maskshow = true;
      this.masktype = "updatecompany";
      this.checkval = id;
      this.checkval.unit_type = 1;
    },

    onmodify(id,num) {
      if (num >= 3) {
        this.mas = '短信发送次数已达上限！'
        const hs = this.$createElement; 
        this.$msgbox({
          title: "重发短信通知",
          message: hs("div", null, [
            hs(
              "p",
              { style: "marginBottom:10px;fontSize:16px;color:#303140;fontWeight: bold;" },
              `${this.mas}`
            ),
            hs(
              "p",
              { style: "marginBottom:10px；fontSize:14px;color:#8A8A9A" },
              "对同一背调人最多发送" 
            ),
            hs(
              "span",
              {style: "marginBottom:10px；fontSize:14px;color:#FF6752;position:absolute;left: 201px;top: -30px"},
              "3次"
            ),
            hs(
              "span",
              {style: "marginBottom:10px；fontSize:14px;color:#8A8A9A;position:absolute;left: 226px;top: -30px"},
              "短信,目前已发送"
            ), hs(
              "span",
              {style: "marginBottom:10px；fontSize:14px;color:#FF6752;position:absolute;left: 328px;top: -30px"},
              `${num}次`
            )
          ]),
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          iconClass: "el-icon-caveat",
          confirmButtonText: "关闭",
          cancelButtonText: "",
          showCancelButton:false
        });
      } else {
        this.mas = '是否重新发送短信通知？'
        const h = this.$createElement; 
        this.$msgbox({
          title: "重发短信通知",
          message: h("div", null, [
          h(
            "p",
            { style: "marginBottom:10px;fontSize:16px;color:#303140;fontWeight: bold;" },
            `${this.mas}`
          ),
          h(
            "p",
            { style: "marginBottom:10px；fontSize:14px;color:#8A8A9A" },
            "对同一背调人最多发送" 
          ),
          h(
            "span",
            {style: "marginBottom:10px；fontSize:14px;color:#FF6752;position:absolute;left: 201px;top: -30px"},
            "3次"
          ),
           h(
            "span",
            {style: "marginBottom:10px；fontSize:14px;color:#8A8A9A;position:absolute;left: 226px;top: -30px"},
            "短信,目前已发送"
          ), h(
            "span",
            {style: "marginBottom:10px；fontSize:14px;color:#FF6752;position:absolute;left: 328px;top: -30px"},
            `${num}次`
          )
        ]),
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        iconClass: "el-icon-caveat",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          biId: id,
        };
        return this.$axios
          .post("/bi/againAuthMsg?biId="+id)
          .then((res) => {
            this.$message.success(res.data.message);
            this.loadData();
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      });
      }
    },
    onAuthority(id) {
      // this.$router.push({
      //   path: "ssgBacktone/result",
      //   query: {
      //     id: id,
      //   },
      // });

       const routeData = this.$router.resolve({
          path: "ssgBacktone/result",
          query: {
            id: id,
          },
        });
        window.open(routeData.href, "_blank");
    },
    //分页方法
    cur(val) {
      this.form.pageNum = val;
      this.loadData();
    },
    search() {
      this.pageNum = 1;
      this.loadData();
    },
    seal(userId, status) {
      if (status == 1) {
        status = false;
      } else if (status == 0) {
        status = true;
      }

      return this.$axios
        .post(
          "userInfo/operateServerUser?userId=" + userId + "&status=" + status
        )
        .then((res) => {
          this.$message.success(res.data.message);
          this.loadData();
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
  },
};
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../assets/css/common/lableTable.less" scoped lang="less"></style>
<style src="../../assets/css/common/operating.less" scoped lang="less"></style>

<style scoped lang="less">
.el-main {
  height: calc(100vh - 60px);
}
 /deep/ .el-main{
  padding: 20px 0;
}
.tab_nav {
  border-bottom: none;
}

.form {
  margin: 23px 0;
}

.el-form-item {
  margin-bottom: 15px;
}

.span_bgc {
  padding: 2px 9px;
  background: #FFFDEC;
  border-radius: 4px;
  border:  1px solid #E7D8A0;
  font-size: 12px;
  font-weight: 400;
  color:  #E7B802;;
}

.span_bgc4 {
  padding: 2px 9px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  border: 1px solid #b7e1d3;
  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  // margin: 33px 0 14px 0;
}
.smallTitle {
  font-size: 12px;
  font-weight: 400;
  color: #303140;
}
.filterdiv {
  width: 100%;
  /*margin: 32px 0;*/
  padding: 17px 18px 17px 0;
  background-color: #f2f5f8;
  box-sizing: border-box;
  border: 1px solid #d9dbe2;
  border-radius: 4px;
  .residence {
    /deep/.el-form-item__label {
      width: 60px;
    }
  }
  .registered {
    /deep/.el-form-item__label {
      width: 72px;
    }
  }
}
.filterdiv {
  /deep/.el-form-item__content {
    height: 32px;
    line-height: 32px;
    // padding-left: 10px;
  }
}
// .formslot .el-form-item {
//   margin-left: 0;
//   // margin-right: 7px;

//   .el-input {
//     height: 32px;
//     line-height: 32px;
//   }
//   /deep/.el-input__inner {
//     height: 32px;
//     line-height: 32px;
//   }
//   /deep/.el-form-item__label {
//     line-height: 32px;
//     font-size: 12px;
//   }
//   .block {
//     height: 32px;
//     .el-cascader {
//       height: 32px;
//       line-height: 32px;
//       /deep/.el-input {
//         height: 32px;
//       }
//       /deep/.el-input__inner {
//         height: 32px !important;
//       }
//     }
//   }
// }
// .el-form /deep/ .el-form-item__label {
//   // padding: 0 14px 0 0;
//   width: 60px;
// }
// .el-form-item {
//   margin: 6px 13px;
// }


.formslot .el-form-item {
  /deep/.el-form-item__content {
    display: flex;
    height: 32px;
    align-items: center;
    flex: 1;
    .el-checkbox{
      .el-checkbox__label{
        font-size: 12px;
      }
    }
    .el-cascader{
      .el-cascader__tags{
        .el-tag{
          background: #409eff;
          color: #fff;
          .el-tag__close{
            background: #409eff;
            color: #fff;  
            top: 1px;
          }
        }
      }
    }
  }
  height: 32px;
  line-height: 32px;
  margin: 6px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  /deep/.el-input {
    // height: 32px;
    width: 100%;
    min-height: 32px;
    line-height: 32px;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
    }
    .el-icon-circle-close:before {
      right: 0;
    }
  }
  /deep/.el-form-item__label {
    height: 32px;
    line-height: 32px;
    width: 75px;
    font-size: 12px;
  }
}

  




.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
.safe{
  color: #3AC697;
  font-weight: 400;
}
.unsafe {
  color:  #FF6752;
  font-weight: 400;
}
.table /deep/ .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
  padding-left: 0;
}
.table /deep/ .el-table th>.cell{
  color: #545566;
  font-weight: bold;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}

.table /deep/ .el-table__row{
  height: 40px;
}
</style>
